<template>
  <div class="question">
    <div class="loader absolute" v-if="loading"></div>
    <router-link tag="div" :to="{name:'question-view', params: {id: question.id}}" class="title cursor-pointer">
      {{ question.title }}
    </router-link>
    <div class="content">
      <p class="mb-0">{{ question.content }}</p>
      <div class="images mt-2" v-if="question.images.length">
        <question-images :images="question.images"/>
      </div>
      <div class="audio mt-2" v-if="question.audio">
        <audio-player class="audio-player" :src="question.audio"/>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <img :src="question.user.avatar" alt="" class="avatar">
        <span class="name">{{ question.user.full_name }}</span>
        <span class="date">{{ moment(question.date).format("DD MMMM YYYY") }}</span>
      </div>
      <div class="right">
        <template v-if="canReply">
          <i class="fa fa-reply hover-primary cursor-pointer" @click="reply"></i>
          <span class="separator"></span>
        </template>
        <div class="actions">
          <span>{{ question.likes }}</span>
          <i @click="like(true)" class="ti-thumb-up hover-primary" :class="{'text-green':hasLike}"></i>
          <span>{{ question.dislikes }}</span>
          <i @click="like(false)" class="ti-thumb-down hover-danger" :class="{'text-danger':hasDislike}"></i>
        </div>
        <span class="separator" v-if="question.responses_count || isUserQuestion"></span>
        <span class="responses" v-if="question.responses_count">
          {{ question.responses_count }} réponses
        </span>
        <template v-if="isUserQuestion">
          <div class="actions">
            <i class="ti-pencil hover-primary" @click="edit"></i>
            <i class="ti-trash hover-danger" @click="remove"></i>
          </div>
        </template>
        <template v-if="seeMore">
          <span class="separator"></span>
          <router-link tag="button" :to="{name:'question-view', params: {id: question.id}}"
                       class="show btn btn-gray">
            Voir plus
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {mapActions, mapGetters} from 'vuex';
import QuestionImages from "@/components/Questions/QuestionImages";

export default {
  name: 'Question',
  props: {
    question: {type: Object, default: null},
    no_answer_btn: {type: Boolean, default: false},
    showCommentStat: {type: Boolean, default: true},
    canUpdate: {type: Boolean, default: true},
    canDelete: {type: Boolean, default: true},
    showMore: {type: Boolean, default: true}
  },
  components: {
    QuestionImages,
  },
  data() {
    return {
      showFloat: false,
      loading: false
    }
  },
  methods: {
    ...mapActions({
      setActiveQuestion: 'question/setActiveQuestion'
    }),
    moment,
    showFloatComment() {
      this.setActiveQuestion(this.item)
    },
    updateComment() {
      this.showFloat = true;
    },
    reply() {
      this.$root.$emit('reply-question', this.question)
    },
    edit() {
      this.$root.$emit('edit-question', this.question)
    },
    remove() {
      this.loading = true
      this.$store.dispatch('question/removeItem', {itemId: this.question.id}).then(() => {
        this.$emit('refreshData', true);
      }).finally(() => this.loading = false)
    },
    like(like) {
      this.loading = true
      this.$store.dispatch('question/like', {
        itemId: this.question.id,
        like,
        remove: (like && this.hasLike) || (!like && this.hasDislike)
      }).then(({data}) => {
        this.question.like = data.like;
        this.question.likes = data.likes;
        this.question.dislikes = data.dislikes;
      })
        .finally(() => this.loading = false)
    }
  },
  computed: {
    ...mapGetters(['user']),
    isUserQuestion() {
      return this.question.user.id === this.user.id
    },
    seeMore() {
      return this.showMore && !this.question.response_to
    },
    hasLike() {
      return this.question.like === 1
    },
    hasDislike() {
      return this.question.like === 0
    },
    canReply() {
      return !this.question.response_to
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.question {
  position: relative;

  .title {
    color: $green;
    font-size: 18px;
    font-weight: 500;
  }

  .content {
    font-weight: 300;
    font-size: 16px;
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    padding-top: 5px;
    padding-bottom: 5px;

    .left {
      display: flex;
      align-items: center;
      @include gap-items-x(3px);

      .name {
        font-weight: 600;
        display: block;
        @include no-break();
        max-width: 200px;
      }

      .date {
        font-size: 14px;
      }
    }

    .right {
      display: flex;
      @include gap-items-x(3px);
      align-items: center;

      .separator {
        display: block;
        height: 80%;
        border-left: 1px solid #ccc;
      }

      .actions {
        display: flex;
        align-items: center;
        @include gap-items-x(3px);

        i {
          cursor: pointer;
        }

        i, span {
          font-size: 20px;
          line-height: 20px;
        }
      }

      button {
        border: none;
        outline: none;
        font-size: 12px;
        padding: 5px 10px;
      }
    }
  }
}
</style>

